<template>
    <div class="main">
        <c-panel :title="modoEdicao ? 'EDITAR TIPO DE AVALIAÇÃO' : 'NOVO TIPO DE AVALIAÇÃO'" titleIcon="fas fa-edit">

            <div v-if="!carregado" class="u-text-center u-mt-25">
                <img src="/public/img/loading-bar.gif" />
            </div>

            <el-form v-else label-position="top" :model="dados" ref="dados" @submit.native.prevent="salvar">

                <el-alert type="info" :closable="false" class="u-mb-15"
                    title="A natureza define quais campos são utilizados. Os campos que não se aplicam à natureza escolhida ficam ocultos e são enviados em branco."></el-alert>

                <el-row :gutter="10">
                    <el-col :xs="24" :sm="10">
                        <el-form-item label="Nome" prop="nome" :rules="[$requiredBlur]">
                            <el-input v-model="dados.nome" maxlength="191" show-word-limit></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="10">
                        <el-form-item label="Natureza" prop="natureza" :rules="[$requiredChange]">
                            <el-select v-model="dados.natureza" style="width: 100%;" @change="aoTrocarNatureza">
                                <el-option v-for="n in naturezas" :key="n" :value="n" :label="rotuloNatureza(n)"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="4">
                        <el-form-item label="Situação">
                            <el-select v-model="dados.situacao" style="width: 100%;">
                                <el-option :value="true" label="ATIVO"></el-option>
                                <el-option :value="false" label="INATIVO"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>

                <!-- Grupo de conceitos: conceitual e conceitual_numerica -->
                <el-row :gutter="10" v-if="ehConceitual">
                    <el-col :xs="24" :sm="12">
                        <el-form-item label="Grupo de conceitos">
                            <el-select v-model="dados.grupo_conceito_id" style="width: 100%;" filterable clearable>
                                <el-option v-for="g in gruposDisponiveis" :key="g.id" :value="g.id" :label="g.nome"></el-option>
                            </el-select>
                            <small v-if="dados.natureza === 'conceitual_numerica'" style="color: #909399;">
                                Apenas grupos marcados com correspondente numérico podem ser usados aqui.
                            </small>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-alert v-if="dados.natureza === 'conceitual_numerica' && !gruposDisponiveis.length"
                    type="warning" :closable="false" class="u-mb-15"
                    title="Nenhum grupo de conceitos está marcado como possuindo correspondente numérico. Configure as faixas dos conceitos e marque o grupo antes de criar este tipo."></el-alert>

                <!-- Campos de nota: numerica e conceitual_numerica -->
                <template v-if="aceitaNota">
                    <el-row :gutter="10">
                        <el-col :xs="12" :sm="5">
                            <el-form-item label="Nota mínima">
                                <el-input v-model="dados.nota_minima" v-mask="'###,##'" placeholder="0"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="12" :sm="5">
                            <el-form-item label="Nota máxima">
                                <el-input v-model="dados.nota_maxima" v-mask="'###,##'" placeholder="10"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="12" :sm="5">
                            <el-form-item label="Média de aprovação">
                                <el-input v-model="dados.media_aprovacao" v-mask="'###,##'" placeholder="6"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="12" :sm="4">
                            <el-form-item label="Casas decimais">
                                <el-select v-model="dados.casas_decimais" style="width: 100%;">
                                    <el-option v-for="c in [0,1,2,3,4,5,6]" :key="c" :value="c" :label="String(c)"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="5">
                            <el-form-item label="Arredondamento">
                                <el-select v-model="dados.arredondamento" style="width: 100%;">
                                    <el-option v-for="a in arredondamentos" :key="a" :value="a" :label="rotuloArredondamento(a)"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-row :gutter="10">
                        <el-col :xs="12" :sm="5">
                            <el-form-item label="Qtd. de exames finais">
                                <el-input v-model="dados.qtd_exames_finais" v-mask="'##'" placeholder="0"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="12" :sm="5" v-if="Number(dados.qtd_exames_finais) > 0">
                            <el-form-item label="Média do exame final">
                                <el-input v-model="dados.media_exame_final" v-mask="'###,##'"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="6">
                            <el-form-item label="Recuperação por período">
                                <el-select v-model="dados.permite_recuperacao_periodo" style="width: 100%;">
                                    <el-option :value="true" label="PERMITE"></el-option>
                                    <el-option :value="false" label="NÃO PERMITE"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </template>

                <el-alert v-if="dados.natureza === 'parecer_descritivo'" type="info" :closable="false" class="u-mb-15"
                    title="O parecer descritivo não utiliza nota, média, exame final nem grupo de conceitos."></el-alert>

                <el-row class="u-mt-15">
                    <el-col :xs="24" class="u-text-right">
                        <router-link to="/admin/tipo-avaliacao">
                            <el-button>VOLTAR</el-button>
                        </router-link>
                        <el-button class="u-ml-10" type="primary" native-type="submit">SALVAR</el-button>
                    </el-col>
                </el-row>
            </el-form>
        </c-panel>
    </div>
</template>

<script>
export default {
    data: () => ({
        dados: {
            nome: '', natureza: 'numerica', grupo_conceito_id: '',
            nota_minima: '', nota_maxima: '', media_aprovacao: '', media_exame_final: '',
            casas_decimais: 1, arredondamento: 'meio_acima', qtd_exames_finais: '',
            permite_recuperacao_periodo: true, situacao: true
        },
        naturezas: [],
        arredondamentos: [],
        gruposConceito: [],
        modoEdicao: false,
        carregado: false
    }),
    computed: {
        ehConceitual () { return ['conceitual', 'conceitual_numerica'].includes(this.dados.natureza) },
        aceitaNota () { return ['numerica', 'conceitual_numerica'].includes(this.dados.natureza) },
        // Para conceitual_numerica só os grupos com correspondente numérico servem —
        // é o mesmo filtro que o TipoAvaliacaoService aplica ao validar.
        gruposDisponiveis () {
            if (this.dados.natureza !== 'conceitual_numerica') return this.gruposConceito
            return this.gruposConceito.filter(g => g.possui_correspondente_numerico === true)
        }
    },
    mounted () { this.initForm() },
    methods: {
        rotuloNatureza (n) {
            const r = {
                numerica: 'Numérica',
                parecer_descritivo: 'Parecer descritivo',
                conceitual: 'Conceitual',
                conceitual_numerica: 'Conceitual com correspondente numérico'
            }
            return r[n] || n
        },
        rotuloArredondamento (a) {
            const r = {
                nenhum: 'Nenhum', baixo: 'Truncar (para baixo)', cima: 'Sempre para cima',
                meio_acima: 'Meio para cima', meio_abaixo: 'Meio para baixo'
            }
            return r[a] || a
        },
        // Ao trocar a natureza, limpa o que não se aplica. O backend continua sendo a
        // autoridade: ele recusa campo preenchido em natureza que não o utiliza.
        aoTrocarNatureza () {
            if (!this.ehConceitual) this.dados.grupo_conceito_id = ''
            if (!this.aceitaNota) {
                this.dados.nota_minima = ''
                this.dados.nota_maxima = ''
                this.dados.media_aprovacao = ''
                this.dados.media_exame_final = ''
                this.dados.qtd_exames_finais = ''
            }
        },
        initForm () {
            this.$axios.get(
                `${this.$store.state.config.baseUrlApi}/api/tipo-avaliacao/initForm`,
                this.$store.getters.getHeaderAuth
            ).then(r => {
                this.naturezas = r.data.naturezas || []
                this.arredondamentos = r.data.arredondamentos || []
                this.gruposConceito = r.data.grupos_conceito || []
                if (this.$route.params.id) {
                    this.modoEdicao = true
                    this.carregar(this.$route.params.id)
                } else {
                    this.carregado = true
                }
            }).catch(e => this.$store.commit('throwException', e))
        },
        carregar (id) {
            this.$axios.get(
                `${this.$store.state.config.baseUrlApi}/api/tipo-avaliacao/getById/${id}`,
                this.$store.getters.getHeaderAuth
            ).then(r => {
                const reg = r.data || {}
                Object.keys(this.dados).forEach(k => {
                    if (reg[k] !== undefined && reg[k] !== null) this.dados[k] = reg[k]
                })
                this.dados.situacao = reg.situacao === false ? false : true
                this.dados.permite_recuperacao_periodo = reg.permite_recuperacao_periodo === false ? false : true
                this.carregado = true
            }).catch(e => this.$store.commit('throwException', e))
        },
        salvar () {
            this.$refs.dados.validate(valid => {
                if (!valid) {
                    window.eventBus.$emit('alert', { msg: 'Preencha os campos obrigatórios.', type: 'warning' })
                    return
                }
                window.eventBus.$emit('loading', true)
                const url = this.modoEdicao
                    ? `${this.$store.state.config.baseUrlApi}/api/tipo-avaliacao/update/${this.$route.params.id}`
                    : `${this.$store.state.config.baseUrlApi}/api/tipo-avaliacao/store`
                this.$axios.post(url, this.dados, this.$store.getters.getHeaderAuth).then(r => {
                    window.eventBus.$emit('loading', false)
                    if (r.data && r.data.erro) {
                        window.eventBus.$emit('alert', { msg: typeof r.data.erro === 'string' ? r.data.erro : r.data.erro.text, type: 'warning' })
                        return
                    }
                    window.eventBus.$emit('alert', { msg: 'Salvo com sucesso.', type: 'success' })
                    this.$router.push('/admin/tipo-avaliacao')
                }).catch(e => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', e) })
            })
        }
    }
}
</script>
